import { Route } from "react-router-dom";
import ClientAddTicket from "../components/ClientAddTicket";
import ClientTicketList from "../components/ClientListTicket";

import ClientMiddleware from "../../client-middleware/components";

const ClientTicketRoutes = () => (
  <>
    <Route path="/tickets" element={<ClientMiddleware><ClientTicketList /></ClientMiddleware>} />
    <Route path="/add-ticket" element={<ClientMiddleware><ClientAddTicket /></ClientMiddleware>} />
  </>
);


export default ClientTicketRoutes;